<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
      :margin="$attrs.margin"
    >
      <div class="custom-file">
        <input
          id="customFile"
          ref="fileInput"
          type="file"
          :multiple="multiple"
          :accept="accept"
          class="custom-file-input"
          :disabled="uploadPending || disabled"
          @change="upload"
        >
        <label
          class="custom-file-label"
          for="customFile"
        >Datei<span v-if="multiple">(n)</span> hochladen <i
          v-if="uploadPending"
          class="fa fa-circle-o-notch fa-spin"
        />
        </label>
      </div>
      <small
        v-if="$attrs.small"
        class="text-muted d-block"
      >{{ $attrs.small }}</small>
      <transition-group
        v-if="files.length && !hideFileList"
        name="user"
        tag="ul"
        class="list-group list-group-flush mt-3"
      >
        <li
          v-for="(file, fileIndex) of files"
          :key="file._id"
          class="list-group-item px-2 py-2"
        >
          <div
            class="form-row align-items-center"
          >
            <div class="col">
              <a
                :download="file.name"
                :href="file.downloadUrl"
              >{{ file.name }}</a>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-link p-0"
                @click="removeFileFromList(fileIndex)"
              >
                <i class="fas fa-trash text-danger" />
              </button>
            </div>
          </div>
        </li>
      </transition-group>
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
// import feathers from '@/api'
// import axios from 'axios'
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicInput',
  mixins: [basicComponentMixin],
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => {}
    },
    hideFileList: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    uploadPending: false
  }),
  computed: {
    files () {
      const files = []
      if (this.model) {
        if (Array.isArray(this.model)) {
          files.push(...this.model)
        } else {
          files.push(this.model)
        }
      }
      return files
    }
  },
  methods: {
    async upload (event) {
      if (this.uploadPending || !event.target.files || !event.target.files[0]) return
      try {
        this.uploadPending = true

        if (this.multiple) {
          const toUploadFiles = []
          for (let key in event.target.files) {
            if (typeof event.target.files[key] === 'object') {
              toUploadFiles.push(event.target.files[key])
            }
          }
          const files = await Promise.all(toUploadFiles.map(async (toUploadFile) => {
            const file = await this.uploadFile(toUploadFile)
            return file
          }))
          this.$emit('uploaded', files)
          this.model = files
        } else {
          const toUploadFile = event.target.files[0]
          const file = await this.uploadFile(toUploadFile)
          this.$emit('uploaded', file)
          this.model = file
        }
      } catch (error) {
        console.error(error)
      } finally {
        // reset fileInput
        this.$refs.fileInput.value = ''
        if (this.$refs.fileInput.value) {
          this.$refs.fileInput.type = 'text'
          this.$refs.fileInput.type = 'file'
        }
        this.uploadPending = false
      }
    },
    async uploadFile (toUploadFile) {
      // const file = await feathers.service('file').create({
      //   name: toUploadFile.name,
      //   type: toUploadFile.type
      // })
      // await axios.put(file.uploadUrl, toUploadFile, this.config)
      // return file
    },
    removeFileFromList (index) {
      if (this.multiple) {
        this.model.splice(index, 1)
        this.$emit('removed', index)
      } else {
        this.model = null
        this.$emit('removed')
      }
    }
  }
}
</script>
